export const buttonComment = {
  hoiku: '\\ ホイクぺディア公式LINE /',
  frog: '\\ Frog公式LINE /',
};